import { TenantedPropertyDetailsModel, TenancyType } from '@urbanx/agx.campaigns.client';
import { AgxBadge, AgxSpacer } from '@urbanx/agx.ui-components2';
import CampaignOverviewInfoCard from './CampaignOverviewInfoCard';
import CampaignOverviewSection from './CampaignOverviewSection';
import ContactDetails from './ContactDetails';

const tenancyLabels: Record<TenancyType, string> = {
  [TenancyType.NotTenanted]: 'Not tenanted',
  [TenancyType.TenantedAgencyManaged]: 'Agency managed',
  [TenancyType.TenantedSelfManaged]: 'Self managed',
  [TenancyType.TenantedAgencyManagedHolidayRental]: 'Holiday rental',
  [TenancyType.Unknown]: 'Not recorded',
};

const TenancyOverview = ({ details }: { details?: TenantedPropertyDetailsModel }) => {
  const tenancyType = details?.tenancyType ?? TenancyType.Unknown;
  const isTenanted = ![TenancyType.NotTenanted, TenancyType.Unknown].includes(tenancyType);
  const propertyManagerName = [details?.contactName, details?.agencyName]
    .filter(Boolean)
    .join(' at ');
  const selfManagedFallback =
    tenancyType === TenancyType.TenantedSelfManaged
      ? 'Managed by the vendor'
      : 'Managing agency not recorded';
  const untenantedMessage =
    tenancyType === TenancyType.NotTenanted
      ? 'No current tenancy'
      : 'Tenancy information has not been completed';

  return (
    <CampaignOverviewSection id="tenancy" label="Tenancy">
      <CampaignOverviewInfoCard>
        <ContactDetails
          id="tenancy-contact"
          name={isTenanted ? propertyManagerName || selfManagedFallback : undefined}
          email={isTenanted ? details?.agencyEmail : undefined}
          phone={isTenanted ? details?.agencyPhone : undefined}
          emptyMessage={untenantedMessage}
          badge={
            tenancyType !== TenancyType.NotTenanted && (
              <AgxSpacer direction="horizontal" flexShrink={0} style={{ width: 'fit-content' }}>
                <AgxBadge
                  type="colourfill"
                  colour={isTenanted ? 'yellow' : 'lightgrey'}
                  size="sm"
                  text={tenancyLabels[tenancyType]}
                />
              </AgxSpacer>
            )
          }
        />
      </CampaignOverviewInfoCard>
    </CampaignOverviewSection>
  );
};

export default TenancyOverview;
